import { render, staticRenderFns } from "./shzb.vue?vue&type=template&id=7ce01c80&scoped=true"
import script from "./shzb.vue?vue&type=script&lang=js"
export * from "./shzb.vue?vue&type=script&lang=js"
import style0 from "./shzb.vue?vue&type=style&index=0&id=7ce01c80&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ce01c80",
  null
  
)

export default component.exports